export default __webpack_public_path__ + "a127f7d919438998f83e1faa7efa8f31.svg";